<script>
export default {
	data() {
		return {
			date: '20261023',
			version: 'v1.0.97',
			erudaClickCount: 0,
			erudaClickResetTimer: null
		}
	},
	methods: {
		onFooterClick() {
			this.erudaClickCount++;
			if (this.erudaClickResetTimer) {
				clearTimeout(this.erudaClickResetTimer);
			}
			if (this.erudaClickCount >= 10) {
				this.erudaClickCount = 0;
				this.loadEruda();
			} else {
				this.erudaClickResetTimer = setTimeout(() => {
					this.erudaClickCount = 0;
					this.erudaClickResetTimer = null;
				}, 2000);
			}
		},
		loadEruda() {
			if (window.eruda) {
				window.eruda.init();
				return;
			}
			const script = document.createElement('script');
			script.src = 'https://cdn.jsdelivr.net/npm/eruda';
			script.onload = () => {
				if (window.eruda) {
					window.eruda.init();
				}
			};
			document.head.appendChild(script);
		}
	}
}
</script>
<template>
	<!-- BEGIN #footer -->
	<div id="footer" class="app-footer" style="font-size: 0.5rem; text-align: end; padding: 0px; padding-right: 1rem;" @click="onFooterClick">
		&copy; {{ date }}-{{ version }} All Right Reserved
	</div>
	<!-- END #footer -->
</template>
